/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Contact_TitleInputs */

const en_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const fr_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const es_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const it_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatti`)
};

const nl_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const pl_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const fi_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteystiedot`)
};

const da_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const sv_impressum_contact_title = /** @type {(inputs: Impressum_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Impressum_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_contact_title = /** @type {((inputs?: Impressum_Contact_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Contact_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_contact_title(inputs)
	if (locale === "fr") return fr_impressum_contact_title(inputs)
	if (locale === "es") return es_impressum_contact_title(inputs)
	if (locale === "it") return it_impressum_contact_title(inputs)
	if (locale === "nl") return nl_impressum_contact_title(inputs)
	if (locale === "pl") return pl_impressum_contact_title(inputs)
	if (locale === "fi") return fi_impressum_contact_title(inputs)
	if (locale === "da") return da_impressum_contact_title(inputs)
	if (locale === "sv") return sv_impressum_contact_title(inputs)
	return en_impressum_contact_title(inputs)
});